import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-sword-line text-lg text-background-50"></i>
              </div>
              <span className="text-lg font-bold font-heading text-background-50">
                刃牙漫画
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-400 mb-4">
              刃牙漫画在线观看平台，提供全集下拉式即时阅读体验。
              无需下载，流畅浏览全部章节。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              <a href="/category/all">漫画分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/fighting" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">格斗漫画</Link></li>
              <li><Link to="/category/hot-blooded" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">热血漫画</Link></li>
              <li><Link to="/category/classic" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">经典名作</Link></li>
              <li><Link to="/category/latest" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">最新上架</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              <a href="/">热门推荐</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/article/baki-the-grappler" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">刃牙</Link></li>
              <li><Link to="/article/baki-ii" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">刃牙II</Link></li>
              <li><Link to="/article/hanma-baki" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">範馬刃牙</Link></li>
              <li><Link to="/article/baki-dou-ii" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">刃牙道II</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              <a href="/about">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">联系我们</Link></li>
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">阅读指南</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200">用户反馈</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2020 - {new Date().getFullYear()} 刃牙漫画在线观看. 本站内容仅供学习交流使用.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</Link>
            <Link to="/" className="text-xs text-background-500 hover:text-background-300 transition-colors">服务条款</Link>
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}